/**
 * @generated SignedSource<<25cd0727e877bd297a034b02a868b5c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CcpEntitlementStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type tenantContextProviderQuery$variables = {
  hostNames?: ReadonlyArray<string> | null;
};
export type tenantContextProviderQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudId: string;
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly status?: CcpEntitlementStatus | null;
      } | null;
      readonly entitlementId: string;
    } | null;
    readonly orgId: string;
  } | null>;
};
export type tenantContextProviderQuery = {
  response: tenantContextProviderQuery$data;
  variables: tenantContextProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hostNames"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "hostNames",
    "variableName": "hostNames"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cloudId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgId",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "devai.ondemand"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entitlementId",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "CcpEntitlement",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tenantContextProviderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "TenantContext",
          "kind": "LinkedField",
          "name": "tenantContexts",
          "plural": true,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v2/*: any*/),
              "action": "THROW",
              "path": "tenantContexts.cloudId"
            },
            {
              "kind": "RequiredField",
              "field": (v3/*: any*/),
              "action": "THROW",
              "path": "tenantContexts.orgId"
            },
            {
              "alias": null,
              "args": (v4/*: any*/),
              "concreteType": null,
              "kind": "LinkedField",
              "name": "entitlementInfo",
              "plural": false,
              "selections": [
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "entitlement",
                  "plural": false,
                  "selections": [
                    (v6/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "entitlementInfo(hamsProductKey:\"devai.ondemand\")"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "tenantContexts"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tenantContextProviderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"devai.ondemand\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f22e22f3982f8d26e0a23898b5f9bbbc",
    "id": null,
    "metadata": {},
    "name": "tenantContextProviderQuery",
    "operationKind": "query",
    "text": "query tenantContextProviderQuery(\n  $hostNames: [String!]\n) {\n  tenantContexts(hostNames: $hostNames) {\n    cloudId\n    orgId\n    entitlementInfo(hamsProductKey: \"devai.ondemand\") {\n      __typename\n      entitlementId\n      entitlement {\n        __typename\n        ... on CcpEntitlement {\n          status\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b15fe3d52428f9cb93757fbfeb7bd5d";

export default node;
